import { authSplitApi } from '../helpers/slice.helpers';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { TSsoConfigurationDB, TSsoConfigurationUI, TSsoConfigureUI } from 'data/types/sso.types';
import { ssoConfigurationConverter, ssoConfigureConverter } from 'data/converters/sso.converters';

const { PROPERTY_MANAGER } = EPropertyMangerUrl;

export const ssoApi = authSplitApi('ssoApi', ['SsoConfiguration']).injectEndpoints({
  endpoints: (build) => ({
    getSsoConfiguration: build.query<TSsoConfigurationUI | null, void>({
      query() {
        return {
          url: `${PROPERTY_MANAGER}/sso/configuration`,
          method: 'GET',
        };
      },
      transformResponse: (data: TSsoConfigurationDB | null) => (data ? ssoConfigurationConverter.fromDb(data) : null),
      providesTags: ['SsoConfiguration'],
    }),
    configureSso: build.mutation<void, TSsoConfigureUI>({
      query(data) {
        return {
          url: `${PROPERTY_MANAGER}/sso/configure`,
          method: 'POST',
          body: ssoConfigureConverter.toDb(data),
        };
      },
      invalidatesTags: ['SsoConfiguration'],
    }),
    deleteSsoConfiguration: build.mutation<void, void>({
      query() {
        return {
          url: `${PROPERTY_MANAGER}/sso/configuration`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['SsoConfiguration'],
    }),
    enableSso: build.mutation<void, void>({
      query() {
        return {
          url: `${PROPERTY_MANAGER}/sso/enable`,
          method: 'PATCH',
        };
      },
      invalidatesTags: ['SsoConfiguration'],
    }),
    disableSso: build.mutation<void, void>({
      query() {
        return {
          url: `${PROPERTY_MANAGER}/sso/disable`,
          method: 'PATCH',
        };
      },
      invalidatesTags: ['SsoConfiguration'],
    }),
  }),
});

export const {
  useGetSsoConfigurationQuery,
  useConfigureSsoMutation,
  useDeleteSsoConfigurationMutation,
  useEnableSsoMutation,
  useDisableSsoMutation,
} = ssoApi;
